'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__Button_index_js_97ed6304__ from "../../Button/index.js";
function Footer({ footerLeftNode, handleFooterCallBack }) {
    const onClickChange = ()=>{
        handleFooterCallBack(false);
    };
    const classes = footerLeftNode ? 'justify-between' : 'justify-end';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: `flex w-full items-center pt-4 ${classes}`,
        children: [
            footerLeftNode ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                children: footerLeftNode
            }) : null,
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Button_index_js_97ed6304__.Button, {
                size: "sm",
                type: "primary",
                onClick: onClickChange,
                children: "Done"
            })
        ]
    });
}
export { Footer };
